import script from "./TboSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./TboSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./TboSidebar.vue?vue&type=style&index=0&id=5d1dcad2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d1dcad2"]])

export default __exports__